import React, { useState, useEffect } from "react";
import Header from "./Header";
import SideMenu from "./SideMenu";
import Login from "./Modals/Login";
import Menu from "./Modals/Menu.js";
import { useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";

const Wrapper = ({
  url,
  user,
  payload,
  unlisted,
  pub_user,
  shouldRegister,
  clearRegister,
  navigatePage,
  login,
  setVideos,
  logout,
  color,
  home,
  title,
  company,
  children,
}) => {
  const [visible, setVisible] = useState(false);
  const [menu, setMenu] = useState(false);
  const {darkMode} = useContext(GlobalContext)
   useEffect(() => {
    if (shouldRegister) {
      clearRegister();
      setVisible(true);
    }
  }, [shouldRegister]);

  return (
    <div>
      <Header
        url={url}
        unlisted={unlisted}
        visible={visible}
        setVisible={setVisible}
        menu={menu}
        setMenu={setMenu}
        pub_user={pub_user}
        user={user}
        setVideos={setVideos}
        color={color}
        title={title}
        home={home}
      />

      {!unlisted && <SideMenu color={color} navigatePage={navigatePage} payload={payload} /> }
      
      <Menu
        color={color}
        visible={menu}
        pub_user={pub_user}
        company={company}
        close={() => setMenu(false)}
        logout={() => {
          logout();
          setMenu(false);
        }}
      />
      
      <Login
        visible={visible}
        companyId={user}
        url={url}
        close={() => setVisible(false)}
        login={(user, creds) => {
          login(user, creds);
          setVisible(false);
        }}
      />

      {/* content of the app */}
      <div className={darkMode?"dark padding":"padding"}>{children}</div>
    </div>
  );
};
export default Wrapper;
